
import { supabase } from "@/integrations/supabase/client";

/**
 * Thoroughly cleans up all authentication state to prevent "limbo" states
 * where users can't properly logout or switch accounts
 */
export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('supabase.auth.token');
  
  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  
  // Remove from sessionStorage if in use
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
};

/**
 * Enhanced sign out function that properly cleans up auth state
 * and performs a global sign out to invalidate all sessions
 */
export const secureSignOut = async () => {
  try {
    // Clean up first to ensure we're starting fresh
    cleanupAuthState();
    
    // Attempt global sign out
    try {
      await supabase.auth.signOut({ scope: 'global' });
    } catch (err) {
      console.error("Global sign out failed, continuing with cleanup", err);
      // Continue even if this fails
    }
    
    return true;
  } catch (error) {
    console.error("Error during secure sign out:", error);
    return false;
  }
};

/**
 * Redirects to login page if user is not authenticated
 */
export const requireAuth = async (navigate: (path: string) => void) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      // Clean up any stale auth state before redirecting
      cleanupAuthState();
      navigate("/admin");
      return false;
    }
    return true;
  } catch (error) {
    console.error("Auth check failed:", error);
    navigate("/admin");
    return false;
  }
};
